import { Status } from "../../models/Status";
import * as T from "./types";

const initialState: T.IState = {
  status: new Status(),
  username: "",
};

export default (state: T.IState = initialState, action) => {
  switch (action.type) {
    case T.RESET_PASSWORD_STATUS:
      return {
        ...state,
        status: action.payload,
      };

    case T.RESET_PASSWORD_USERNAME:
      return {
        ...state,
        username: action.payload,
      };

    default:
      return {
        ...state,
      };
  }
};
